<template>
  <footer class="display-none">
    <p class="m0">{{ description }}</p>
    <small>&copy; 2017 Maich Swift Architects Ltd</small>
  </footer>
</template>

<script>
  export default {
    name: 'app-footer',
    computed: {
      description () {
        return this.$store.state.description
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/partials/AppFooter.vue